import { localisedValue } from "utils"

const regionsTransformer = response => {
  const { regions } = response
  return regions.map(e => {
    const countries = e?.countries?.map(item => ({ ...item, value: item?.id?.toString() }))
    const cities = e?.cities?.map(item => ({ ...item, value: item?.id?.toString() }))
    return {
      ...e,
      id: e.id,
      countries: countries || [],
      cities: cities || [],
      label: localisedValue({ object: e, key: "name" }),
      value: e.id.toString(),
    }
  })
}

export default regionsTransformer
